import { render, staticRenderFns } from "./IconMoney.vue?vue&type=template&id=6b943d04&"
import script from "./IconMoney.vue?vue&type=script&lang=js&"
export * from "./IconMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports